export const PaddingContainer = {
  size: 2,
};
